const NUMBER_FORMAT_LOCALE = 'de-DE'

export const getNumericValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const numericValue = Number(value)

  return Number.isFinite(numericValue) ? numericValue : null
}

export const formatNumber = (
  value,
  {minimumFractionDigits = 0, maximumFractionDigits = 2, fallback = '-'} = {}
) => {
  const numericValue = getNumericValue(value)

  if (numericValue === null) {
    return fallback
  }

  return new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(numericValue)
}

export const formatFixedNumber = (value, digits = 2, options = {}) =>
  formatNumber(value, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
    ...options,
  })

export const formatHectares = (value, digits = 2, options = {}) =>
  `${formatFixedNumber(value, digits, options)} ha`

export const formatPercent = (value, digits = 2, options = {}) =>
  `${formatFixedNumber(value, digits, options)}%`

export const formatMeters = (value, digits = 1, options = {}) =>
  `${formatFixedNumber(value, digits, options)} m`
